const DataScienceSkillsCircleLoop = (props) => {
  let solidArr = [];
  let regularArr = [];

  for (let i = 0; i < props.solid; i++) {
    solidArr.push(<i className="fas fa-circle"></i>);
  }

  for (let i = 0; i < props.regular; i++) {
    regularArr.push(<i className="far fa-circle"></i>);
  }

  return (
    <div className="row">
      <div className="col">{props.lang}</div>
      <div className="col d-flex">
        <span className="circleMargin">{solidArr}</span>
        <span className="circleMargin">{regularArr}</span>
      </div>
    </div>
  );
};

export default DataScienceSkillsCircleLoop;
